export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "user_roles",
      layout: "dashboard",
    },
    path: "/user",
    name: "users",
    component: () => import("@/layouts/index/UsersIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Roles",
          layout: "dashboard",
        },
        path: "roles/index",
        name: "users-roles-index",
        component: () => import("@/views/user_roles/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Creer un role",
          layout: "dashboard",
        },
        path: "roles/create",
        name: "users-roles-create",
        component: () => import("@/views/user_roles/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le role",
          layout: "dashboard",
        },
        path: ":reference/roles/create",
        name: "users-roles-edit",
        component: () => import("@/views/user_roles/Edit.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Utilisateurs d'application",
          layout: "dashboard",
        },
        path: "index",
        name: "users-index",
        component: () => import("@/views/users/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un nouvel utilisateur",
          layout: "dashboard",
        },
        path: "create",
        name: "users-create",
        component: () => import("@/views/users/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Creer un produit",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "users-edit",
        component: () => import("@/views/users/Edit.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Authentifications d'utilisateurs d'application",
          layout: "dashboard",
        },
        path: "authentications",
        name: "authentications-index",
        component: () => import("@/views/users/Authentications.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "IPs Autorisées",
          layout: "dashboard",
        },
        path: "allowed-ips",
        name: "allowed-ips-index",
        component: () => import("@/views/users/AllowedIPs.vue"),
      },
    ],
  },
];
